Vue.component('competition', {
	props: ['user', 'teams', 'competitor_teams'],
	computed: {
		myTeamName() {
			return Spark.state.currentTeam.name
		},
		formattedParams() {
			let prms = this.params

			try {
				prms.toDate = prms.toDate.format("YYYY-MM-DD")
				prms.fromDate = prms.fromDate.format("YYYY-MM-DD")
			} catch(error) {
				//
			}

			return prms
		},
		settingsOpen() {

			if (this.competitors != null && Object.keys(this.competitors).length == 1) {
				return true
			}

			return this.openedSettings

		},
		myHotelSources() {
			if (! this.competitors || this.competitors.length == 0 || !this.competitors[0]) {
				return []
			}

			return Object.keys(this.competitors[0].ratings_by_source)
		},
		myHotelCategories() {
			if (! this.competitors || this.competitors.length == 0 || !this.competitors[0]) {
				return []
			}

			return Object.keys(this.competitors[0].sentiment_by_category)	
		},
		currentOutOf() {
			if (this.activeComparisonType == 'average_rating') {

				if (! this.params.source || this.params.source == '') {

					return 5

				} else {

					try {
						return this.competitors[0].ratings_by_source[this.params.source].out_of
					} catch (error) {
						//
					}

				}

			} else if (this.activeComparisonType == 'sentiment') {
				return 100
			} else {
				return ''
			}

		},
		competitorsUsage() {
			const team = Spark.state.currentTeam;
			if (!team) return 'Loading competitors…';

			const usedCompetitors = (this.competitors || [])
				.filter(c => c.team_id !== team.id)
				.length;

			return `${usedCompetitors}/${team.max_competitors} Competitors`;
		}
	},
	data() {
		return {
			competitors: null,
			hidden: [],
			params: {
				travelerType: '',
				fromDate: moment().startOf('year'),
				toDate: moment(),
				source: '',
				category: '',
				reviewsType: ''
			},
			sentimentBreakdown: [],
			updatingComp: false,
			updatingSentiment: false,
			openedSettings: false,
			activeComparisonType: 'average_rating',
			averageRatings: null,
			sentiment: null,
			reviews: null
		}
	},
	mounted() {
		this.$eventHub.$on('updateCompetitionDates', (from, to) => {
			this.updateDates(from, to)
		});

		this.$eventHub.$on('updateCompetitors', this.updateCompetitors)
		this.$eventHub.$on('closeSettings', this.closeSettings)
		this.$eventHub.$on('openComparison', (type) => this.openComparison(type))
		this.$eventHub.$on('updateComparison', (type) => this.updateComparison(type, true))
		this.$eventHub.$on('applyCompetitionSourceFilter', (source) => this.applySource(source))
		this.$eventHub.$on('applyCompetitionCategoryFilter', (category) => this.applyCategory(category))

		this.$eventHub.$on('activateTab', (id) => {
			if (id == 'competition' && this.competitors == null) {
				this.updateCompetitors()
				this.switchComparison('average_rating')
			}
		});

		this.$eventHub.$on('toggleAll', className => this.expandBreakdown(className));
	},
	methods: {
		expandBreakdown(className) {
			if (className == 'element-sentiment' && !this.sentimentBreakdown || this.sentimentBreakdown.length == 0) {
				this.getSentimentBreakdown();
			}
		},
		labelize(comparison_type) {

			if (comparison_type == 'average_rating') {
				return 'AVERAGE RATING'
			}

			return comparison_type

		},
		switchComparison(type) {

			// analytics.track("Compared Metric In Competition", {
   //      comparison_type: type
   //    })

			this.hidden = []
			this.activeComparisonType = type

			// Load data only if it hasn't been loaded already to allow faster
			// switching.
			if (
				(type == 'average_rating' && ! this.averageRatings) ||
				(type == 'sentiment' && ! this.sentiment) ||
				(type == 'reviews' && ! this.reviews)
			) {
				this.updateComparison(type)
			}
		},
		// Applies a source filter and updates the active comparison modal
		applySource(source) {
			this.params.source = source
			this.updateComparison(this.activeComparisonType)
		},
		// Applies a sentiment category filter
		applyCategory(category) {
			this.params.category = category
			this.updateComparison(this.activeComparisonType)
		},
		toggleDataset(index) {

			if (this.hidden.includes(index)) {
				var i = this.hidden.indexOf(index);
				if (i !== -1) this.hidden.splice(i, 1);
			} else {
				this.hidden.push(index)
			}

			this.$eventHub.$emit('toggleDataset', index)

		},
		openComparison(type, open = true) {

			$(this.$refs.compare_modal).modal('toggle')

			this.activeComparisonType = type

			this.updateComparison(type)
		},
		updateComparison(type, new_date=false) {

			// When the date changes, we need to force-update the other
			// datasets as well.
			if (new_date) {
				this.averageRatings = null
				this.sentiment = null
				this.reviews = null
			}

			if (type == 'average_rating') {

				this.getAverageRatings()

			} else if (type == 'sentiment') {

				this.getSentiment()

			} else if (type == 'reviews') {
				
				this.getReviews()

			}
		},
		getAverageRatings() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

			let url = '/api/competitors/' + Spark.state.currentTeam.id + '/average-ratings'
				+ '?' + params_string

			axios.get(url)
			.then(response => {

				this.averageRatings = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		async getSentimentBreakdown() {
			let params = this.formattedParams
			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')
			this.updatingSentiment = true;
			const response = await axios.get('/api/competitors/' + Spark.state.currentTeam.id + '/group-stats?' + params_string);
			this.sentimentBreakdown = response.data;
			this.updatingSentiment = false;
			const copy = this.competitors;
			for (let group of this.sentimentBreakdown) {
				for (let competitorIndex in group.data) {
					if (!copy[competitorIndex].sentimentByGroup) {
						copy[competitorIndex].sentimentByGroup = [];
					}
				}
			}
		},
		getSentiment() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

			let url = '/api/competitors/' + Spark.state.currentTeam.id + '/sentiment'
				+ '?' + params_string

			axios.get(url)
			.then(response => {

				this.sentiment = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		getReviews() {
			let params = this.formattedParams
			params['type'] = 'competition'

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

			let url = '/api/competitors/' + Spark.state.currentTeam.id + '/reviews'
				+ '?' + params_string

			axios.get(url)
			.then(response => {

				this.reviews = response.data

			}).catch(error => {
				console.log(error)
			})
		},
		closeSettings() {
			this.openedSettings = false
		},
		updateCompetitors() {

			// Cancel any hidden comparative set from before
			this.hidden = []
			
			let params = this.formattedParams

			var params_string = Object.keys(params).map(function(k) {
                return params[k] == '' ? ''
                    : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
            }).join('&')

			this.updatingComp = true

			axios
				.get('/api/competitors/' + Spark.state.currentTeam.id + '?' + params_string)
				.then((response) => {
					this.competitors = response.data;
					this.updatingComp = false;
				})
				.catch((error) => {
					this.competitors = [];
					this.updatingComp = false;
				});

			// If a sentiment breakdown has already been loaded, we
			// need to update it whenever the competition is updated.
			if (this.sentimentBreakdown && this.sentimentBreakdown.length > 0) {
				this.getSentimentBreakdown();
			}
		},
		updateDates(from, to) {

			// analytics.track("Filtered By Date In Competition", {
			// 	from: from,
			// 	to: to
			// })

			this.params.fromDate = from
			this.params.toDate = to

			this.updateCompetitors()
		},
		comparisonScore(comp) {

			if (this.activeComparisonType == 'average_rating') {

				if (! this.params.source || this.params.source == '') {
					return comp.ratings_total_average
				} else {
					return comp.ratings_by_source[this.params.source].average
				}

			} else if (this.activeComparisonType == 'sentiment') {

				if (! this.params.category || this.params.category == '') {
					return comp.sentiment_total_average
				} else {
					return comp.sentiment_by_category[this.params.category].average
				}

			} else if (this.activeComparisonType == 'reviews') {


				if (! this.params.source) {

					return comp.reviews_total_count

				} else {
					
					return comp.ratings_by_source[this.params.source].count

				}

			}

		}
	}
})

Vue.component('competition-source-picker', {
	props: ['active_source', 'available_sources'],
	template: `

	<div class="dropdown square d-inline-block">
            
        <div class="dropdown-select" data-toggle="dropdown">
            <span v-if="active_source != ''">{{ sourceLabelFromSlug(active_source) }}</span>
            <span v-else>All Review Sites</span>
        </div>
        
        <div class="dropdown-menu dropdown-scroll">
            <a  class="dropdown-item"
               :class="{active: active_source == ''}"
               href="#" @click.prevent="enableFilter('')">All Review Sites</a>
            <a v-for="source in available_sources"
               class="dropdown-item"
               :class="{active: active_source == source}"
               href="#" @click.prevent="enableFilter(source)">{{ sourceLabelFromSlug(source) }}</a>
        </div>
    </div>
	`,

	methods: {
		enableFilter(source) {
			this.$eventHub.$emit('applyCompetitionSourceFilter', source)
		}
	}
})

Vue.component('competition-category-picker', {
	props: ['active_category', 'available_categories'],
	template: `

	<div class="dropdown square d-inline-block">
            
        <div class="dropdown-select" data-toggle="dropdown">
            <span v-if="active_category != ''">{{ active_category }}</span>
            <span v-else>All Categories</span>
        </div>
        
        <div class="dropdown-menu dropdown-scroll">
            <a  class="dropdown-item"
               :class="{active: active_category == ''}"
               href="#" @click.prevent="enableFilter('')">All Categories</a>
            <a v-for="category in available_categories"
               class="dropdown-item"
               :class="{active: active_category == category}"
               href="#" @click.prevent="enableFilter(category)">{{ category }}</a>
        </div>
    </div>
	`,

	methods: {
		enableFilter(category) {
			this.$eventHub.$emit('applyCompetitionCategoryFilter', category)
		}
	}
})